import { INITIAL_SCHEMA } from '@/helpers/dev';

function setParents(items) {
  let parents = [];

  for (let i in items) {
    parents.push({ id: items[i].id, name: items[i].name });

    if (items[i].children) {
      for (let j in items[i].children) {
        parents.push({ id: items[i].children[j].id, name: items[i].children[j].name });
      }
    }
  }

  return parents;
}

export default {
  setMenus: (state, payload) => {
    const menus = payload.map(menu => {
      !menu.procedure && (menu.procedure = '');

      return menu;
    });

    const parents = setParents(menus);

    state.parents = parents;
    state.navItems = menus;
  },

  setPages: (state, payload) => (state.pages = payload),

  setEnvironments: (state, payload) => (state.environments = payload),

  clearMenus: state => (state.navItems = []),

  setSchema: (state, payload = JSON.parse(JSON.stringify(INITIAL_SCHEMA))) => {
    state.schema = payload;
    state.modes = [];

    'list' in state.schema && state.modes.push('list');
    'form' in state.schema && state.modes.push('form');
    'new' in state.schema && state.modes.push('new');
    'search' in state.schema && state.modes.push('search');
    'sidebar' in state.schema && state.modes.push('sidebar');
  },

  setSelected: (state, payload) => (state.selected = payload),

  setInitialSchema: (state, payload) => (state.initialSchema = payload),

  setModes: (state, payload) => (state.modes = payload),

  setTypeOfPageEditing: (state, payload) => (state.typeOfPageEditing = payload),

  setConfirmPageChanges: (state, payload) => (state.confirmPageChanges = payload),

  setSelectedTab: (state, payload) => (state.selectedTab = payload),

  setSelectedStep: (state, payload) => (state.selectedStep = payload),

  setActiveTab: (state, payload) => (state.activeTab = payload),

  setActiveStep: (state, payload) => (state.activeStep = payload),

  setConfigLayout: (state, payload) => (state.configLayout = payload),

  setCurrentMode: (state, payload) => (state.currentMode = payload),

  setCurrentTemplate: (state, payload) => (state.currentTemplate = payload),

  setSelectedPortal: (state, payload) => (state.selectedPortal = payload),

  setSelectedModule: (state, payload) => (state.selectedModule = payload),

  setSelectedEnvironment: (state, payload) => (state.selectedEnvironment = payload),

  setSelectedPage: (state, payload) => (state.selectedPage = payload),

  setSelectedItem: (state, payload) => (state.selectedItem = payload),

  setParents: (state, payload) => (state.parents = payload),

  setAccordionType: (state, payload) => (state.accordionType = payload),

  setSelectedComponent: (state, payload) => (state.selectedComponent = payload),

  setSidebarTab: (state, payload) => (state.sidebarTab = payload),

  logoff: (state) => {
    state.environments = [];
    state.modes = [];
    state.pages = [];
    state.navItems = [];
    state.parents = [];
    state.currentTemplate = 'templateHome';
    state.typeOfPageEditing = '';
    state.selectedPage = '';
    state.selected = {};
    state.selectedItem = {};
    state.currentMode = null;
    state.selectedTab = null;
    state.selectedStep = null;
    state.activeTab = null;
    state.activeStep = null;
    state.selectedEnvironment = null;
    state.selectedPortal = null;
    state.selectedModule = null;
    state.selectedComponent = false;
    state.accordionType = null;
    state.sidebarTab = null;
  }
};
